import { ScenarioActions } from '~/actions/'

const initialState = {
  
}

function scenarioSave( state = initialState, action ) {
  switch ( action.type ) {

    case ScenarioActions.SAVING_SCENARIO:
    case ScenarioActions.SAVED_SCENARIO: {
      const id = action.scenario.id
      const s = { ...state }
      s[id] = { saving : action.type == ScenarioActions.SAVING_SCENARIO, error : false, id, exception : null }
      return s
    }

    case ScenarioActions.SAVE_ERROR_SCENARIO: {
      const id = action.scenario.id
      const s = { ...state }
      return { saving : false, error : true, id, exception : action.exception }
    }

    default:
      return state
  }
}

module.exports = scenarioSave
